import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type VhcRecordsRepairOrderQuoteProps = {
  id: number;
  userId?: number;
};

export const useVhcRecordsRepairOrderQuoteMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.postVhcRecordsRepairOrderQuote>>,
      QueryError,
      VhcRecordsRepairOrderQuoteProps,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, userId }: VhcRecordsRepairOrderQuoteProps) => {
      return VhcRecordLogService.postVhcRecordsRepairOrderQuote(id, userId);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully created!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
